/**
 *
 * @module ordinal
 * @description Ordinals for numbers, such as 1st, 2nd, 3rd, 4th
 * @author Stu Kabakof
 * @author Greg Babula [greg.babula@mlb.com]
 *
 */

/* global module */

(function(root, factory) {

    if (typeof define === 'function' && define.amd) {
        define('ordinal/ordinal',[], factory);
    } else if (typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.bamOrdinal = factory();
    }

}(this, function() {

    'use strict';

    var exports = {};

    /**
     *
     * @method en
     * @param {Number} number
     * @returns {String} ordinal
     *
     */
    exports.en = function(number) {

        var numberStr = number.toString();
        var lastDigit = numberStr.charAt(numberStr.length - 1);
        var ordinalNumber = number > 20 ? lastDigit : numberStr;

        switch(ordinalNumber) {
            case '1':
                return 'st';
            case '2':
                return 'nd';
            case '3':
                return 'rd';
            default:
                return 'th';
        }

    };

    /**
     *
     * @method es
     * @param {Number} number
     * @returns {String} ordinal
     *
     */
    exports.es = function(number) {

        var numberStr = number.toString();

        switch(numberStr) {
            case '1':
            case '3':
                return 'ra';
            case '2':
                return 'da';
            case '4':
            case '5':
            case '6':
                return 'ta';
            case '7':
            case '10':
            case '12':
                return 'ma';
            case '8':
                return 'va';
            case '9':
                return 'na';
            case '11':
                return 'mo';
            default:
                return 'to';
        }

    };

    return exports;

}));

